// Einheitliche Dokument-Begriffe – identisch mit backend/dokument_kategorien_routes.py
export const DOK_KATEGORIEN = {
  BG: { label: "Bildungsgutschein", gruppe: "aufnahme" },
  MV: { label: "Maßnahmevertrag", gruppe: "aufnahme" },
  DS: { label: "Datenschutz-Einwilligung", gruppe: "aufnahme" },
  EG: { label: "Erstgespräch", gruppe: "aufnahme" },
  FZ: { label: "Führungszeugnis", gruppe: "aufnahme" },
  AL: { label: "Anwesenheitsliste", gruppe: "kurs" },
  KB: { label: "Klassenbuch", gruppe: "kurs" },
  AU: { label: "AU-Bescheinigung", gruppe: "kurs" },
  SP: { label: "Stundenplan", gruppe: "kurs" },
  PV: { label: "Praktikumsvertrag", gruppe: "praktikum" },
  LZ: { label: "Praktikums-Laufzettel", gruppe: "praktikum" },
  PB: { label: "Praktikumsbewertung", gruppe: "praktikum" },
  PR: { label: "Prüfungsunterlagen", gruppe: "abschluss" },
  ZE: { label: "Zertifikat", gruppe: "abschluss" },
  TB: { label: "Teilnehmerbefragung", gruppe: "abschluss" },
  AM: { label: "Austrittsmeldung", gruppe: "abschluss" },
  RE: { label: "Rechnung", gruppe: "weitere" },
  SO: { label: "Sonstige", gruppe: "weitere" },
};

export const DOK_GRUPPEN = [
  { key: "aufnahme", label: "Aufnahme" },
  { key: "kurs", label: "Kursverlauf" },
  { key: "praktikum", label: "Praktikum" },
  { key: "abschluss", label: "Abschluss" },
  { key: "weitere", label: "Weitere" },
];

const ALIASE = {
  bildungsgutschein: "BG", "maßnahmevertrag": "MV", massnahmevertrag: "MV", schulungsvertrag: "MV",
  datenschutz: "DS", datenschutz_einwilligung: "DS", "erstgespräch": "EG", erstgespraech: "EG",
  "führungszeugnis": "FZ", fuehrungszeugnis: "FZ", praktikumsvertrag: "PV", laufzettel: "LZ",
  bw: "PB", bewertung: "PB", praktikumsbewertung: "PB", an: "AL", anwesenheit: "AL", anwesenheitsliste: "AL",
  klassenbuch: "KB", "au-bescheinigung": "AU", stundenplan: "SP", pruefung: "PR", "prüfung": "PR",
  pruefungsunterlagen: "PR", "prüfungsunterlagen": "PR", zertifikat: "ZE", zeugnis: "ZE",
  befragung: "TB", teilnehmerbefragung: "TB", rechnung: "RE", sonstige: "SO", sonstiges: "SO",
  austrittsmeldung: "AM", austritt: "AM", "nichtantritts-/austrittsmeldung": "AM",
};

export const katCode = (raw) => {
  const v = String(raw || "").trim();
  if (DOK_KATEGORIEN[v.toUpperCase()]) return v.toUpperCase();
  return ALIASE[v.toLowerCase()] || "SO";
};

export const katLabel = (raw) => DOK_KATEGORIEN[katCode(raw)].label;

// Pflichtunterlagen: nur AZAV-relevante TN (BG + Kurs 1232/1013/1045); Praktikum nur 1232 – Regel kommt vom Backend (azav_regel.py)
export const pflichtCodes = (regel) => {
  if (!regel?.azav) return [];
  return ["BG", "MV", "DS", "EG", "AL", ...(regel.praktikum ? ["PV", "LZ", "PB"] : [])];
};

export const dokumenteNachCode = (anhaenge) =>
  (anhaenge || []).reduce((acc, a) => {
    let c = katCode(a.kategorie);
    if (c === "SO" && /austritt/i.test(a.filename || "")) c = "AM";
    (acc[c] = acc[c] || []).push(a);
    return acc;
  }, {});
